import {createContext} from 'react';

const ActionContext = createContext({ dispatch: () => {} })
export default ActionContext;